import { ServerMovementProductType, ServerTransactionByIdType } from '@expane/data'

export const extractInServiceConsumablesQty = (transactionById: ServerTransactionByIdType) => {
  const consumablesInServices: Record<number, number> = {}
  for (const { service } of transactionById.transactionsServices) {
    if (service.serviceProducts.length) {
      for (const consumable of service.serviceProducts) {
        if (consumablesInServices[consumable.productId])
          consumablesInServices[consumable.productId] += consumable.quantity
        else consumablesInServices[consumable.productId] = consumable.quantity
      }
    }
  }

  return consumablesInServices
}

export const flatTransactionMovements = (transactionById: ServerTransactionByIdType) => {
  const movementProducts: ServerMovementProductType[] = []

  for (const { movement } of transactionById.transactionMovements) {
    for (const consumable of movement.movementProducts) {
      // Перевіряємо тільки productId, бо при оплаті все одно ціна буде однакова на товари
      const addedIndex = movementProducts.findIndex(mP => mP.productId === consumable.productId)
      if (addedIndex === -1) {
        movementProducts.push({ ...consumable, product: { ...consumable.product } })
      } else {
        movementProducts[addedIndex].quantity += consumable.quantity
      }
    }
  }

  return movementProducts
}
